import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Typography, Box} from 'views/components';
import {Translate, translate, MarkdownViewer} from 'views/module';

import FixedReview from './Review/FixedReview';
import RecurrenceReview from './Review/RecurrenceReview';
import LiveInReview from './Review/LiveInReview';

const SelectEventType = (props) => {
  const eventType = props.eventType;
  const newEvent = props.newEvent;
  const setIsStepValid = props.setIsStepValid;
  React.useEffect(() => {
    setIsStepValid(true);
  }, []);

  return (
    <Stack spacing={1} >
      <Stack>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.Title'/>
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {
            eventType === 'FIXED_EVENT' &&
            translate('client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.FixedEventTitle')
          }
          {
            eventType === 'RECURRENCE_EVENT' &&
            translate('client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.RecurringEventTitle')
          }
          {
            eventType === 'LIVEIN_EVENT' &&
            translate('client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.LiveInEventTitle')
          }
        </Typography>
      </Stack>
      <Stack>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.Title'/>
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {newEvent.info.title}
        </Typography>
      </Stack>
      <Stack>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.Description'/>
        </Typography>
        <Box
          sx={{
            fontSize: '14px',
          }}
        >
          {
            !newEvent.info.description.blob &&
            translate('client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.NoDescription')
          }
          {
            newEvent.info.description.blob &&
            <MarkdownViewer
              value={newEvent.info.description.blob}
              truncate={true}
            />
          }
        </Box>
      </Stack>
      {
        eventType === 'FIXED_EVENT' &&
        <FixedReview {...props} />
      }
      {
        eventType === 'RECURRENCE_EVENT' &&
        <RecurrenceReview {...props} />
      }
      {
        eventType === 'LIVEIN_EVENT' &&
        <LiveInReview {...props} />
      }
      <Stack>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.Caregiver.CaregiverSearch'/>
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {newEvent.caregiverData.caregiver.caregiverName}
        </Typography>
      </Stack>
    </Stack>
  );
};

SelectEventType.propTypes = {
  newEvent: PropTypes.object.isRequired,
  eventType: PropTypes.string.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, dispatch)(React.memo(SelectEventType));
